module.exports = __webpack_public_path__ + "static/media/company.b1199e1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/company.jpg
// module id = 327
// module chunks = 0